<template>
  <div class="modal fade" id="terminationPolicyModal" @keyup.esc.prevent="closeModal" tabindex="-1" aria-labelledby="terminationPolicyModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div v-if="!loaded && !!policy && !!policyType" class="modal-content">
        <div class="modal-header p-5 justify-content-between">
          <h5 class="modal-title" id="terminationPolicyModal">
            {{ policy.number ?? policy.global }}
          </h5>
          <button @click="closeModal" type="button" id="closeTerminationPolicy" class="btn-close ms-10"></button>
        </div>
        <div class="modal-body p-5">
          <section class="policy-info__detail mb-3">
            <div class="podft-list p-4 rounded border">
              <div class="podft-list__item">
                <div class="text-gray-600 fs-7">
                  Номер договора
                  <span class="text-gray-800 float-end">{{policy.number ?? policy.global}}</span>
                </div>
              </div>
              <div class="podft-list__item">
                <div class="text-gray-600 fs-7">
                  Создал (ИИН)
                  <span class="text-gray-800 float-end">{{ policyType === 1 ? policy.client_iin : policy?.client?.iin ?? '' }}</span>
                </div>
              </div>
              <div class="podft-list__item">
                <div class="text-gray-600 fs-7">
                  Продукт
                  <span class="text-gray-800 float-end">{{ policyType === 1 ? policy.product : policy?.product?.title ?? '' }}</span>
                </div>
              </div>
              <div class="podft-list__item">
                <div class="text-gray-600 fs-7">
                  Премия
                  <span class="text-gray-800 float-end">{{ policy.premium ? policy.premium.toLocaleString('ru-RU')+' тг.' : '' }}</span>
                </div>
              </div>
              <div v-if="policyType === 1" class="podft-list__item">
                <div class="text-gray-600 fs-7">
                  Сумма возврата
                  <span class="text-gray-800 float-end">{{ policy.refund ? policy.refund.toLocaleString('ru-RU')+' тг.' : '' }}</span>
                </div>
              </div>
              <div v-if="policyType === 1 && policy.signinType" class="podft-list__item">
                <div class="text-gray-600 fs-7">
                  Способ подписания
                  <span class="text-gray-800 float-end">{{ policy.signinType == 1 ? 'ОТП' : 'Бумажный' }}</span>
                </div>
              </div>
              <div v-if="policyType === 1 && policy.returnType" class="podft-list__item">
                <div class="text-gray-600 fs-7">
                  Способ возврата
                  <span class="text-gray-800 float-end">{{ policy.returnType == 1 ? 'Наличные' : 'Карточный счет' }}</span>
                </div>
              </div>
              <div class="podft-list__item">
                <div class="text-gray-600 fs-7">
                  Создан
                  <span class="text-gray-800 float-end">{{ policyType === 1 ? policy.created_at : policy?.date ?? '' }}</span>
                </div>
              </div>
              <div class="podft-list__item">
                <div class="text-gray-600 fs-7">
                  Срок действия
                  <div class="float-end">
                    <span class="badge badge-light-primary">{{ policy?.date_from }}</span>
                    - <span class="badge badge-light-danger">{{ policy?.date_to }}</span>
                  </div>
                </div>
              </div>
              <div class="podft-list__item">
                <div class="text-gray-600 fs-7">
                  Статус
                  <span class="text-gray-800 float-end">{{ policyType === 1 ? policy.status : policy?.status?.title }}</span>
                </div>
              </div>
            </div>
            <div v-if="policyType === 1 && policy.document" class="p-3 rounded border d-flex justify-content-between">
              <div class="p-2 me-2 w-50px">
                <i class="ki-duotone ki-document fs-2qx">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
              </div>
              <div class="w-100">
                <div class="fs-5 text-gray-700">Заявление на расторжение</div>
                <div>
                  <a href="javascript:void(0)" @click="downloadDocument(policy.document)" download class="text-primary fs-7">Скачать</a>
                  <a href="javascript:void(0)" @click="openDocument(policy.document)" class="text-primary ms-3 fs-7">Открыть</a>
                </div>
                <div v-if="terminationDocumentLoader">
                  <span class="text-primary fs-7">Загрузка...</span>
                </div>
              </div>
            </div>
          </section>
          <section v-if="policyType === 2 && ((policy?.status?.code === '3' || policy?.status?.code === 3) || (policy?.status?.code === '2' || policy?.status?.code === 2))" class="termination">
            <div class="p-3 rounded border mb-5">
              <div class="row align-items-center">
                <div class="col-lg-4 mb-3 mb-lg-0">
                  <div class="text-gray-400 fs-8 text-lg-start text-center">
                    Сумма подлежащей возврату при расторжении договора.
                  </div>
                </div>
                <div class="col-lg-4">
                </div>
                <div class="col-lg-4 text-lg-end text-center">
                  <div v-if="termination.refund" class="text-primary fw-bold fs-3">{{ termination.refund.toLocaleString('ru-RU') }} тг.</div>
                  <button v-else @click="calcTermination" :disabled="terminationCalcLoader" class="btn btn-primary w-100 btn-sm">{{ terminationCalcLoader ? 'Идет калькуляция...' : 'Рассчитать сумму возврата' }}</button>
                </div>
              </div>
            </div>
            <div v-if="termination.refund" class="termination-block">
              <div class="row">
                <h6 class="fs-5 text-gray-700 mb-5">Сформировать заявление на расторжение</h6>
                <div v-if="!sendedOtp" class="col-lg-6">
                  <div class="p-3 rounded border mb-5">
                    <h6 class="fs-7 text-gray-700 mb-3">Способ расчета</h6>
                    <div class="row">
                      <div class="col-lg-6">
                        <radio-field
                            v-model="termination.returnType"
                            :value="1"
                            placeholder="Наличный расчет"
                            type="checkbox"
                            id="termination.returnType.1"
                            class="form-check-sm mb-3 mb-lg-0"
                        />
                      </div>
                      <div class="col-lg-6">
                        <radio-field
                            v-model="termination.returnType"
                            :value="2"
                            placeholder="Карточный расчет"
                            type="checkbox"
                            id="termination.returnType.2"
                            class="form-check-sm mb-3 mb-lg-0"
                        />
                      </div>
                    </div>
                    <div v-if="termination.returnType === 2" class="termination-bank mt-5">
                      <input-field
                          v-model="termination.bank.iik"
                          @focusout="validateIBAN"
                          id="termination.bank.iik"
                          name="termination.bank.iik"
                          :required="true"
                          :has-error="!bankValid"
                          @input="termination.bank.iik=$event.target.value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()"
                          placeholder="ИИК (IBAN)"
                          type="text"
                          mb="3"
                      />
                      <input-field
                          v-model="termination.bank.bik"
                          id="termination.bank.bik"
                          name="termination.bank.bik"
                          :required="true"
                          placeholder="БИК"
                          type="text"
                          mb="3"
                      />
                      <input-field
                          v-model="termination.bank.name"
                          id="termination.bank.name"
                          name="termination.bank.name"
                          :required="true"
                          placeholder="Банк"
                          type="text"
                          mb="3"
                      />
                      <input-field
                          v-model="termination.bank.kbe"
                          id="termination.bank.kbe"
                          name="termination.bank.kbe"
                          :required="true"
                          placeholder="КБЕ"
                          type="text"
                      />
                    </div>
                  </div>
                  <div class="p-3 rounded border mb-5">
                    <h6 class="fs-7 text-gray-700 mb-3">Причина прекращения договора</h6>
                    <select-field
                        v-model="termination.rescindingReason"
                        :required="true"
                        id="filter.product"
                        name="filter.product"
                        :options="{'00000000011':'Досрочное расторжение', '00000000020':'Смерть страхователя'}"
                        placeholder="Причина"
                    />
                  </div>
                </div>
                <div :class="sendedOtp ? 'col-lg-12' : 'col-lg-6'">
                  <div v-if="!sendedOtp" class="p-3 rounded border mb-5">
                    <h6 class="fs-7 text-gray-700 mb-3">Получатель</h6>
                    <input-mask-field
                        v-model="termination.beneficiary.iin"
                        id="termination.beneficiary.iin"
                        name="termination.beneficiary.iin"
                        :mb="3"
                        mask="############"
                        placeholder="ИИН/БИН"
                        type="text"
                    />
                    <input-field
                        v-model="termination.beneficiary.name"
                        id="termination.beneficiary.name"
                        name="termination.beneficiary.name"
                        :required="true"
                        placeholder="ФИО/Наименование Юр. лица"
                        type="text"
                        mb="3"
                    />
                  </div>
                  <div class="p-3 rounded border mb-5">
                    <h6 v-if="!confirmedOtp" class="fs-7 text-gray-700 mb-3">Способ подписания</h6>
                    <template v-if="!confirmedOtp">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio-field
                              v-model="termination.signinType"
                              :disabled="termination.rescindingReason === '00000000020'"
                              :value="1"
                              placeholder="ОТП"
                              type="checkbox"
                              id="termination.signinType.1"
                              class="form-check-sm mb-3 mb-lg-0"
                          />
                        </div>
                        <div class="col-lg-6">
                          <radio-field
                              v-model="termination.signinType"
                              :value="2"
                              placeholder="Бумажный"
                              type="checkbox"
                              id="termination.signinType.2"
                              class="form-check-sm mb-3 mb-lg-0"
                          />
                        </div>
                      </div>
                      <hr class="text-gray-300">
                      <div v-if="termination.signinType === 1" class="termination-otp">
                        <input-mask-field
                            v-if="!sendedOtp"
                            v-model="termination.otp.phone"
                            id="termination.otp"
                            name="termination.otp"
                            :disabled="this.loaded"
                            :required="true"
                            placeholder="Номер телефона"
                            mask="+7(###) ###-####"
                            type="text"
                            mb="3"
                        />
                        <input-mask-field
                            v-else
                            v-model="termination.otp.code"
                            id="otpCode"
                            name="otpCode"
                            :required="true"
                            :mb="3"
                            placeholder="Код подтверждения"
                            mask="####"
                            type="text"
                        />
                        <button v-if="!sendedOtp" @click="sendOtpCode" :disabled="!(termination.otp.phone.length > 15 && formValid)" class="btn btn-light-primary w-100">Отправить смс</button>
                        <template v-else>
                          <div class="row">
                            <div class="col-6">
                              <button
                                  @click="confirmCode"
                                  v-if="termination.otp.code.length >= 4"
                                  type="button"
                                  class="btn btn-primary w-100">
                                Подтвердить код
                              </button>
                              <button
                                  v-else
                                  :disabled="otpCountdown !== 0"
                                  type="button"
                                  class="btn btn-light-warning w-100">
                                <span v-if="!hasOtpSend" class="indicator-label">Повторно отправить код <span v-if="this.otpCountdown > 0"> через {{ this.otpCountdown }} сек.</span></span>
                                <span v-else @click="sendOtpCode">Отправить код заново</span>
                              </button>
                            </div>
                            <div class="col-6">
                              <button
                                  @click="checkConfirmCode"
                                  type="button"
                                  class="btn btn-light-info w-100">
                                Проверить подтверждение
                              </button>
                            </div>
                          </div>
                        </template>
                      </div>
                    </template>
                    <template v-else>
                      <div class="p-3 rounded border mb-5">
                        <div class="d-flex h-100px justify-content-center align-items-center">
                          <span class="text-success fs-3 fw-bold mb-2">Подтверждено</span>
                        </div>
                      </div>
                    </template>
                    <div v-if="termination.signinType === 2 || (termination.signinType === 1 && confirmedOtp)" class="p-3 rounded border d-flex justify-content-between">
                      <div class="p-2 me-2 w-50px">
                        <i class="ki-duotone ki-document fs-2qx">
                          <span class="path1"></span>
                          <span class="path2"></span>
                        </i>
                      </div>
                      <div class="w-100">
                        <div class="fs-5 text-gray-700">Заявление на расторжение</div>
                        <div v-if="!terminationDocument && !terminationDocumentLoader">
                          <template v-if="formValid">
                            <a class="text-primary fs-7" href="javascript:void(0)" @click="createTerminationDocument">Сформировать</a>
                          </template>
                          <template v-else>
                            <span class="text-danger fs-7">Заполните данные корректно</span>
                          </template>
                        </div>
                        <div v-if="terminationDocument && !terminationDocumentLoader">
                          <a href="javascript:void(0)" @click="downloadDocument(this.terminationDocument)" download class="text-primary fs-7">Скачать</a>
                          <a href="javascript:void(0)" @click="openDocument(this.terminationDocument)" class="text-primary ms-3 fs-7">Открыть</a>
                        </div>
                        <div v-if="terminationDocumentLoader">
                          <span class="text-primary fs-7">Загрузка...</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div class="modal-footer p-2 justify-content-between">
          <button type="button" class="btn btn-sm btn-secondary" @click="closeModal">Закрыть</button>
          <button @click="terminatePolicy" v-if="policyType === 2 && formValid && termination.refund > 0" :disabled="termination.signinType === 1 ? !confirmedOtp : false" type="button" class="btn btn-sm btn-danger">Расторгнуть</button>
        </div>
      </div>
      <div class="modal-content" v-else>
        <loader-full style="min-height: 323px"/>
      </div>
    </div>
  </div>
</template>

<script>
import InputMaskField from '@/components/Fields/InputMaskField'
import SelectField    from '@/components/Fields/SelectField'
import LoaderFull     from '@/components/Main/LoaderFull'
import RadioField     from '@/components/Fields/RadioButtonField'
import InputField     from '@/components/Fields/InputField'
// Module
import FiModule from '@/helpers/Modules/Product/FiModule'
import {ulid} from 'ulidx'
import axios       from 'axios'

export default {
  name: 'TerminationPolicyModal',
  components: {
    InputMaskField,
    InputField,
    SelectField,
    RadioField,
    LoaderFull
  },
  props: {
    policy: {
      type: Object,
      required: true
    },
    policyType: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loaded: false,
      policyData: null,
      bankValid: true,
      formValid: true,
      sendedOtp: false,
      confirmedOtp: false,
      otpCountdown: 0,
      hasOtpSend: true,
      terminationCalcLoader: false,
      terminationDocument: null,
      terminationDocumentLoader: false,
      termination: {
        ulid: this.policyType === 1 ? null : ulid(),
        returnType: 1,
        signinType: 2,
        rescindingReason: '00000000011',
        refund: 0,
        commission: 0,
        beneficiary: {
          iin: '',
          surname: '',
          name: '',
          patronymic: '',
        },
        bank: {
          iik: '',
          bik: '',
          name: '',
          kbe: '',
        },
        otp: {
          phone: '',
          code: ''
        }
      },
      terminationTemp: null,
    }
  },
  mounted() {
    setTimeout(() => {
      document.getElementById('terminationPolicyModal').addEventListener('mousedown', (event) => {
        if (event.target.classList.contains('modal')) this.closeModal(true)
      });
    }, 10)
  },
  methods: {
    calcTermination() {
      if (!this.terminationCalcLoader) {
        this.terminationCalcLoader = true
        axios.post('api/contracts/functional/calculate', {...this.termination, ...this.policy})
            .then(res => {
              if (res.data.result) {
                this.termination.refund = res.data.refund
                this.termination.commission = res.data.commission
              } else {
                this.$notifyError(res.data)
              }
            })
            .catch(err => {
              this.$notifyError(err)
            })
            .finally(() => this.terminationCalcLoader = false)
      }
    },
    closeModal(auto = false) {
      if (auto) this.simulateClick()
      window.bootstrap.Modal.getInstance(document.getElementById('terminationPolicyModal')).hide();
      this.$store.commit('setTerminationPolicyModalShow', false);
    },
    validateIBAN() {
      this.bankValid = FiModule.Validator.isValidIBANNumber(this.termination.bank.iik)
    },
    validateForm() {
      if (this.termination.refund > 0) {
        const beneficiaryName = this.termination.beneficiary.name && this.termination.beneficiary.name.length > 0
        let bank = false
        if (this.termination.returnType === 1) {
          bank = true
        } else {
          bank = this.termination.bank.name.length > 0
              && this.termination.bank.bik.length > 0
              && this.termination.bank.iik.length > 0
              && this.termination.bank.kbe.length > 0
        }
        return beneficiaryName && bank
      }
    },
    modalHidden() {
      const myModalEl = document.getElementById('terminationPolicyModal');
      const modal = window.bootstrap.Modal.getInstance(myModalEl);
      modal.hide();
    },
    simulateClick() {
      const el = document.getElementById('closeTerminationPolicy')
      el?.click()
    },
    createTerminationDocumentSimple() {
      return axios.post('api/contracts/functional/create-termination-document', {...this.termination, ...this.policy})
    },
    createTerminationDocument() {
      this.terminationDocumentLoader = true
          this.createTerminationDocumentSimple()
          .then(res => {
            if (res.data.result) {
              this.terminationDocument = res.data.document
            } else {
              this.$notifyError(res.data)
            }
          })
          .catch(err => {
            this.$notifyError(err)
          })
          .finally(() => this.terminationDocumentLoader = false)
    },
    openDocument(documentByte) {
      const byteCharacters = atob(documentByte);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });

      // Создаем временный URL и открываем его
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, '_blank');
    },
    downloadDocument(documentByte) {
      const fileName = 'Заявление о досрочном расторжении полиса.pdf';

      const byteCharacters = atob(documentByte);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(link.href); // чистим
    },
    confirmCode() {
      if (this.termination.otp.code.length > 3) {
        const params = {
          code: this.termination.otp.code,
          ulid: this.termination.ulid,
        }
        this.loaded = true
        axios.post('api/functional/otp/accept', params)
            .then(res => {
              if (res.data.result) {
                this.updateData().then(() => {
                  this.confirmedOtp = true
                })
              } else {
                this.$notifyError(res.data)
              }
            })
            .catch(err => {
              this.$notifyError(err)
            })
            .finally(() => this.loaded = false)
      }
    },
    checkConfirmCode() {
      const params = {
        ulid: this.termination.ulid,
      }
      this.loaded = true
      axios.post('api/functional/otp/check-otp', params)
          .then(res => {
            if (res.data.result) {
              this.updateData().then(() => {
                this.confirmedOtp = true
              })
            } else {
              this.$notifyError(res.data)
            }
          })
          .catch(err => {
            this.$notifyError(err)
          })
          .finally(() => this.loaded = false)
    },
    sendOtpCode() {
      if (this.termination.otp.phone.length > 15) {
        const params = {
          phone: this.termination.otp.phone.replace(/\D/g, ''),
          ulid:  this.termination.ulid,
        }
        this.loaded = true
        this.createTerminationDocumentSimple().then((res) => {
          if (res.data.result) {
            this.terminationDocument = res.data.document;
            axios.post('api/functional/otp/send-sms', params)
                .then(res => {
                  if (res.data.result) {
                    this.sendedOtp = true;
                    this.startOtpTimer();
                  } else {
                    this.$notifyError(res.data)
                  }
                })
                .catch(err => {
                  this.$notifyError(err)
                })
                .finally(() => {
                  this.loaded = false;
                });
          } else {
            this.$notifyError(res.data)
            this.loaded = false;
          }
        });
      }
    },
    terminatePolicy() {
      if (!this.terminationDocument) {
        this.$notifyError({message: 'Необходимо сформировать документ'})
        return
      }
      this.loaded = true
      axios.post('api/contracts/functional/terminate', {ulid: this.termination.ulid})
          .then(res => {
            if (res.data.result) {
              this.closeModal(true)
              this.$emit('reload', true)
              this.$notifySuccess({message: 'Договор '+this.policy.number+' успешно обработан'})
            } else {
              this.$notifyError(res.data)
            }
          })
          .catch(err => {
            this.$notifyError(err)
          })
          .finally(() => this.loaded = false)
    },
    async updateData() {
      return axios.post('/api/contracts/functional/update', {...this.termination, ...this.policy})
    },
    startOtpTimer() {
      this.hasOtpSend = false;
      this.otpCountdown = 60
      this.timer = setInterval(() => {
        this.otpCountdown -= 1
        if (this.otpCountdown === 0) {
          this.hasOtpSend = true;
          clearInterval(this.timer)
        }
      }, 1000)
    },
  },
  watch: {
    'termination.rescindingReason': {
      immediate: true,
      handler(val) {
        if (this.policyType === 2) {
          if (val === '00000000011') {
            this.termination.beneficiary.iin = this.policy.client.iin
            this.termination.beneficiary.name = this.policy.client.title
          } else {
            this.termination.beneficiary.iin = ''
            this.termination.beneficiary.name = ''
            this.termination.signinType = this.termination.signinType === 1 ? 2 : this.termination.signinType;
          }
        }
      }
    },
    termination: {
      deep: true,
      handler(val) {
        this.formValid = this.validateForm()
        const newTermination = JSON.parse(JSON.stringify({ ...val, otp: undefined, signinType: undefined }));
        if (JSON.stringify(newTermination) !== JSON.stringify(this.terminationTemp)) {
          this.terminationDocument = null
          this.terminationTemp = newTermination
        }
      }
    },
    'termination.returnType': {
      immediate: true,
      handler() {
        this.termination.bank = {iik: '', bik: '', name: '', kbe: ''}
        this.bankValid = true
      }
    },
    'termination.signinType': {
      immediate: true,
      handler() {
        if (!this.sendedOtp) {
          this.termination.otp = {phone: '', code: ''}
        }
        this.updateData();
      }
    },
    'termination.bank.iik': {
      deep: true,
      handler(val) {
        if (val) {
          let ibanKZ   = val.length > 1 ? val.slice(0, 2).toLowerCase() === 'kz' : false
          let ibanNum  = val.length > 3 ? /^\d+$/.test(val.slice(2, 4)) : false
          let ibanCode = val.length > 6 ? val.slice(4, 7) : false
          if (ibanKZ && ibanNum && ibanCode) {
            const data = FiModule.Client.bikAndNameByCode(ibanCode)
            if (data && Object.prototype.hasOwnProperty.call(data, 'bik')) {
              this.bankValid = true
              this.termination.bank.name = data.name
              this.termination.bank.bik  = data.bik
              this.termination.bank.kbe  =  this.policy.client.person ? (this.policy.client.resident ? '19' : '29') : (this.policy.client.resident ? '17' : '27')
            } else {
              this.termination.bank.name = ''
              this.termination.bank.bik  = ''
            }
          } else {
            this.termination.bank.name = ''
            this.termination.bank.bik  = ''
          }
        }
        if (!val && !this.termination.bank.kbe) {
          this.termination.bank.name = ''
          this.termination.bank.bik  = ''
        }
      }
    }
  }
}
</script>

<style scoped>
</style>